import { FileAttachmentDTO } from "../file-attachment-dto";

export class ResInstructionDTO {
    public instructionType: ResIntructionType = ResIntructionType.Auction;
    public issuedFrom: Date | string = new Date().toISOString().slice(0,16).split('T')[0];
    public issuedTo: Date | string | null = null;
    public dateComment: string = "";
    public summary: string = "";
    public spreadModel: ResInstructionSpreadModel = ResInstructionSpreadModel.None;
    public enforBmus: string[] = [];
    public closeNotes: string = "";
    public coAssumptionsNotes: string = "";
    public status: string ="";
    public isArchived: boolean = false;
    public continuousMarket: ResContinousMarketData[] = [];
    public closeImage: string | null = null;
    public coAssumptionsImage: string | null = null;
    public createdOn: Date = new Date();
}

export class ResContinousMarketData {
    public product: string = "";
    public volume: number = 0;
    public limitPrice: number = 0;
    public direction: string = "";
    public notes: string = "";
    public executionStrategy: string = "";
    public template: string = "Default";
}

export enum ResInstructionSpreadModel {
    None = 0,
    Spread = 1,
}

export enum ResIntructionType {
    Auction = 0,
    ContinuousMarket = 1,
}